export function isEffect(e) {
    return e && e.isEffect;
}
export function isEffects(effects) {
    return Array.isArray(effects) && effects.every(isEffect);
}
const RESERVED_EFFECTS = [
    "exited",
    "entered",
    "runNextAction",
    "eventualAction",
    "goBack",
    "log",
    "error",
    "warn",
    "noop",
    "task",
    "timeout",
];
export function effect(label, data, executor) {
    if (RESERVED_EFFECTS.includes(label)) {
        throw new Error(`${label} is a reserved effect label, please change the label of your custom effect`);
    }
    return __internalEffect(label, data, executor);
}
export function __internalEffect(label, data, executor) {
    return {
        label,
        data,
        executor: executor || (() => void 0),
        isEffect: true,
    };
}
export function goBack() {
    return __internalEffect("goBack", undefined);
}
export function log(...msgs) {
    return __internalEffect("log", msgs, context => {
        if (context.customLogger) {
            context.customLogger(msgs, "log");
        }
        else if (!context.disableLogging) {
            // tslint:disable-next-line:no-console
            console.log(...msgs);
        }
    });
}
export function error(...msgs) {
    return __internalEffect("error", msgs, context => {
        if (context.customLogger) {
            context.customLogger(msgs, "error");
        }
        else if (!context.disableLogging) {
            // tslint:disable-next-line:no-console
            console.error(...msgs);
        }
    });
}
export function warn(...msgs) {
    return __internalEffect("warn", msgs, context => {
        if (context.customLogger) {
            context.customLogger(msgs, "warn");
        }
        else if (!context.disableLogging) {
            // tslint:disable-next-line:no-console
            console.warn(...msgs);
        }
    });
}
export function noop() {
    return __internalEffect("noop", undefined);
}
export function task(callback) {
    return __internalEffect("task", [callback], callback);
}
export function timeout(ms, action) {
    return __internalEffect("timeout", [ms, action], () => new Promise(resolve => setTimeout(() => resolve(action), ms)));
}
//# sourceMappingURL=effect.js.map